import React from 'react';

import FacebookShareSvg from 'assets/images/facebook-share.svg';

import BaseIcon from './BaseIcon';

const FacebookShareIcon = props => (
  <BaseIcon {...props} src={FacebookShareSvg} />
);

export default FacebookShareIcon;
